module.exports = __webpack_public_path__ + "img/12.0a5d059d.jpg";